import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/Observable';
import { OccupationModal } from './Occupation/Occupation.Modal';
import { AppSettings } from '../../_common/constants/app.constants';
import { utilityService } from '../utility.service';

@Injectable()
export class occupationoppservice {
  ocupancycollection = new Array<OccupationModal>();

  constructor(private http: Http, private utilserv: utilityService) {}
  getOccupancyList(enevelop: any) {
    // return this.http.get(AppSettings.ICEMasterService+'/GetOccupation').map(res => res.json());
    return this.utilserv.restPost(enevelop, AppSettings.ICEMasterService + '/GetOccupationV2');
  }

  // }
  initializeOccupation(response) {
    if (response.Occupations != null && response.Occupations != undefined) {
      sessionStorage.Occupations = JSON.stringify(response.Occupations);
    }
  }

  getoccupationlistLocale() {
    if (this.ocupancycollection.length <= 0) {
      this.reInitializeOccupationList();
    }
    return this.ocupancycollection;
  }

  reInitializeOccupationList() {
    if (sessionStorage.Occupations != undefined) {
      let response = JSON.parse(sessionStorage.Occupations);
      this.setOccupationList(response);
    }
  }

  setOccupationList(response) {
    const lang = sessionStorage.langCode != undefined ? sessionStorage.langCode : 'en';
    response.forEach(element => {
      element.OccupationNames.forEach(reselement => {
        if (reselement.Language == lang.toUpperCase()) {
          let ocp = new OccupationModal();
          ocp.OccupationKey = element.OccupationNames[0].Name;
          ocp.OccupationName = reselement.Name;
          this.ocupancycollection.push(ocp);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/occupation/ocupation.service.ts